<div class="layout-topbar">
    <button
        #menubutton
        class="p-link layout-menu-button layout-topbar-button"
        (click)="layoutService.onMenuToggle()"
    >
        <i class="pi pi-bars"></i>
    </button>

    <a class="layout-topbar-logo" routerLink="/home">
        <!-- Logo Wrapper para logos horizontales o de marca -->
        <div *ngIf="currentUser?.company?.logoUrl" class="topbar-company-logo-wrapper">
            <img [src]="currentUser.company.logoUrl" alt="Logo" class="topbar-company-logo" />
        </div>

        <!-- Círculo de Iniciales (solo si no hay logoUrl) -->
        <div
            *ngIf="!currentUser?.company?.logoUrl"
            class="company-logo-circle"
            [ngStyle]="{
                'background-color': currentUser?.company?.color || '#3B82F6'
            }"
        >
            <span>{{ getCompanyInitial() }}</span>
        </div>

        <div class="company-info">
            <span class="company-name">{{
                currentUser?.company?.name || "Avalanz"
            }}</span>
        </div>
    </a>

    <div class="topbar-spacer"></div>

    <div class="topbar-actions">
        <button
            #notificationButton
            class="p-link layout-topbar-button notification-button"
            (click)="toggleNotifications($event)"
            pTooltip="Notificaciones"
            tooltipPosition="bottom"
        >
            <i class="pi pi-bell"></i>
            <span class="notification-badge" *ngIf="unreadCount > 0">
                {{ unreadCount > 99 ? "99+" : unreadCount }}
            </span>
        </button>

        <!-- Usuario con dropdown usando p-menu -->
        <div
            class="user-info-container"
            *ngIf="currentUser"
            (click)="menu.toggle($event)"
        >
            <div class="user-details">
                <div class="user-name">
                    {{ currentUser.firstName
                    }}{{
                        currentUser.middleName ? " " + currentUser.middleName : ""
                    }}{{
                        currentUser.lastName ? " " + currentUser.lastName : ""
                    }}
                </div>
                <div class="user-department">
                    {{ currentUser.departmentName || "Sin departamento" }}
                </div>
            </div>
            <div class="user-avatar" *ngIf="currentUser.photoProfileUrl" [style.border-color]="currentUser?.company?.color || '#e5e7eb'">
                <img [src]="currentUser.photoProfileUrl" alt="Profile" />
            </div>
            <div
                class="user-avatar user-avatar-placeholder"
                *ngIf="!currentUser.photoProfileUrl"
                [style.background-color]="currentUser?.company?.color || '#e5e7eb'"
                [style.border-color]="currentUser?.company?.color || '#e5e7eb'"
            >
                <span class="avatar-initials" [style.color]="currentUser?.company?.color ? '#ffffff' : '#4b5563'">{{ getUserInitials() }}</span>
            </div>
            <i
                class="pi pi-chevron-down"
                style="font-size: 0.8rem; color: #9ca3af; margin-left: 0.25rem"
            ></i>
        </div>

        <!-- Menu PrimeNG -->
        <p-menu
            #menu
            [model]="userMenuItems"
            [popup]="true"
            appendTo="body"
        ></p-menu>
    </div>

</div>

<!-- Modal para cambiar empresa -->
<p-dialog
    [(visible)]="showCompanySelector"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '520px' }"
    styleClass="company-selector-dialog"
    header="Cambiar Empresa"
>
    <div class="companies-list" *ngIf="companies.length > 0">
        <div
            *ngFor="let company of companies"
            class="company-card"
            [class.selected]="isCurrentCompany(company)"
            [class.loading]="isLoadingCompanies && isCurrentCompany(company)"
            [style.border-color]="isCurrentCompany(company) && company.color ? company.color : null"
            (click)="switchCompany(company)"
        >
            <div class="company-visual">
                <div
                    class="company-logo"
                    *ngIf="company.logoUrl"
                    [ngStyle]="{'background-color': company.color || '#FF6B00'}">
                    <img [src]="company.logoUrl" [alt]="company.name">
                </div>
                <div
                    class="company-icon-fallback"
                    *ngIf="!company.logoUrl"
                    [ngStyle]="{'background-color': company.color || '#FF6B00'}">
                    <i class="pi pi-building"></i>
                </div>
            </div>
            <div class="company-info">
                <h3 class="company-name">{{ company.name }}</h3>
                <div class="company-details">
                    <span class="company-code" *ngIf="company.code">
                        <i class="pi pi-tag"></i>
                        {{ company.code }}
                    </span>
                    <span
                        class="company-color-indicator"
                        *ngIf="company.color"
                        [ngStyle]="{'background-color': company.color}">
                    </span>
                </div>
            </div>
            <div class="company-action">
                <i
                    *ngIf="isCurrentCompany(company) && isLoadingCompanies"
                    class="pi pi-spin pi-spinner"
                    [ngStyle]="{'color': company.color || 'var(--primary-color)'}"
                ></i>
                <i
                    *ngIf="!isCurrentCompany(company) && !isLoadingCompanies"
                    class="pi pi-chevron-right"
                ></i>
                <i
                    *ngIf="isCurrentCompany(company) && !isLoadingCompanies"
                    class="pi pi-check"
                    [ngStyle]="{'color': company.color || 'var(--primary-color)'}"
                ></i>
            </div>
        </div>
    </div>

    <div class="companies-empty" *ngIf="companies.length === 0">
        <i class="pi pi-inbox empty-icon"></i>
        <p>No hay empresas disponibles</p>
    </div>
</p-dialog>

<app-notifications-panel></app-notifications-panel>
<p-toast key="topbar-tst" position="top-right"></p-toast>
